import React, { useEffect } from 'react';

import ContentPageOuterContainer from '../../Components/ContentPageOuterContainer';
import ContentPageInnerContainer from '../../Components/ContentPageInnerContainer';
import ElementContainer from '../../Components/ElementContainer';
import ContentCardWithTitle from '../../Components/ContentCardWithTitle';
import ContentCardWithInfoItem from '../../Components/ContentCardWithInfoItem';
import elementTypes from '../../Editing/Constants/elementTypes';
import AddingContainer from '../../Editing/Components/AddingContainer/AddingContainerForCard';
import { Helmet } from 'react-helmet';
import ContentCardWithLargePhoto from '../../Components/ContentCardWithLargePhoto';

const InfoPage = ({ content, scrollToTop, weddingId }) => {
  useEffect(() => {
    scrollToTop();
  }, [scrollToTop]);

  return (
    <ContentPageOuterContainer>
      <Helmet>
        <title>{`EureHochzeitOnline: ${weddingId} | Info`}</title>
      </Helmet>
      <ContentPageInnerContainer>
        {content.elements.map((item, index) => {
          switch (item.elementType) {
            case elementTypes.pageTitle.name:
              return (
                <ElementContainer key={item.title}>
                  <ContentCardWithTitle
                    title={item.title}
                    subtitle={item.subtitle}
                    substituteLanguage={item.substituteLanguage}
                    editingKeys={{ index: index, contentPage: 'INFO', elementType: elementTypes.pageTitle.name }}
                  ></ContentCardWithTitle>
                  <AddingContainer editingKeys={{ index: index, contentPage: 'INFO' }}></AddingContainer>
                </ElementContainer>
              );
            case elementTypes.infoItem.name:
              return (
                <ElementContainer key={item.title}>
                  <ContentCardWithInfoItem
                    title={item.title}
                    description={item.description}
                    imageUrl={item.imageUrl}
                    imagePosition={item.imagePosition}
                    substituteLanguage={item.substituteLanguage}
                    editingKeys={{
                      index: index,
                      contentPage: 'INFO',
                      elementType: elementTypes.infoItem.name,
                    }}
                  ></ContentCardWithInfoItem>
                  <AddingContainer editingKeys={{ index: index, contentPage: 'INFO' }}></AddingContainer>
                </ElementContainer>
              );
            case elementTypes.largePhotoItem.name:
              return (
                <ElementContainer key={item.title}>
                  <ContentCardWithLargePhoto
                    title={item.title}
                    description={item.description}
                    imageUrl={item.imageUrl}
                    substituteLanguage={item.substituteLanguage}
                    editingKeys={{
                      index: index,
                      contentPage: 'INFO',
                      elementType: elementTypes.largePhotoItem.name,
                    }}
                  ></ContentCardWithLargePhoto>
                  <AddingContainer editingKeys={{ index: index, contentPage: 'INFO' }}></AddingContainer>
                </ElementContainer>
              );
            default:
              return null;
          }
        })}
      </ContentPageInnerContainer>
    </ContentPageOuterContainer>
  );
};

export default InfoPage;
